/**
 * DAFNE App Version Information
 *
 * Build number format: YYYY-MM-DD.N
 * - Date: The date of the build
 * - N: Sequential build number for that day (starting at 1)
 *
 * Increment the BUILD_NUMBER when deploying a new build on the same day.
 * Update BUILD_DATE when deploying on a new day (and reset BUILD_NUMBER to 1).
 */

export const BUILD_DATE = "2026-02-23";
export const BUILD_NUMBER = 7;

/** Full version string in format YYYY-MM-DD.N */
export const VERSION = `${BUILD_DATE}.${BUILD_NUMBER}`;

/** App name */
export const APP_NAME = "DAFNE Diary";

/** Brief description for about box */
export const APP_DESCRIPTION = `A digital companion for DAFNE (Dose Adjustment For Normal Eating) graduates. 
Track your blood glucose, carbs, and insulin doses using the DAFNE methodology.

Features pattern analysis based on OzDAFNE principles to help identify when 
insulin adjustments may be needed.

This app is for educational support only and does not replace medical advice. 
Always consult your diabetes healthcare team before making insulin changes.`;

/** Copyright notice */
export const COPYRIGHT = `© ${new Date().getFullYear()} DAFNE Diary`;

/** Version info object for easy access */
export const VERSION_INFO = {
  name: APP_NAME,
  version: VERSION,
  buildDate: BUILD_DATE,
  buildNumber: BUILD_NUMBER,
  description: APP_DESCRIPTION,
  copyright: COPYRIGHT,
} as const;
